// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import awsCognito from './api/awscognito.js'
import has_expire from './api/jwks.js';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'leaflet/dist/leaflet.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

import { fas } from '@fortawesome/free-solid-svg-icons'; 



/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

import * as VueGoogleMaps from "vue2-google-maps" // Import package
import { faChevronUp, faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons'; // 필요한 아이콘 추가

library.add(fas, faChevronUp, faChevronDown, faTimes); 
/* add icons to the library */
library.add(faUserSecret)
// library.add(fas);

// Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(PerfectScrollbar);
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

// const baseURI = "http://localhost:8081"; // 로컬
const baseURI = "http://54.180.215.7:8081"; // 아마존 서버
// const traceURI = "http://localhost:9997"; // 로컬 추적에 대한 API URL
const traceURI = "http://54.180.215.7:9997"; // 아마존 서버

const api_client = axios.create({
  timeout: 150000,
  headers: {
    'Authorization': ''
  }
});

const trace_api_client = axios.create({
  timeout: 150000,
  headers: {
    'Authorization': ''
  }
});

const uoms = {
  UNIT: "Units",
  CASE: "Cases",
  POUND: "Pounds",
  KILOGRAM: "Kilograms",
  SQUARE_MILE: "Square Miles",
  SQUARE_METER: "Square Meters",
  SQUARE_YARD: "Square Yards",
  BUSHEL_US: "Bushels (US)",
  BUSHEL_UK: "Bushels (UK)",
  GALLON_US: "Gallons (US)",
  GALLON_UK: "Gallons (UK)",
  LITER: "Liters",
  CUBIC_METER: "Cubic Meters"
}

Vue.prototype.$getUoms = function () {
  return uoms;
};

Vue.prototype.$hateaos = function (response) {
  if (response && response.data) {
    return response.data._embedded ? response.data._embedded : response.data;
  }
};
Vue.prototype.$hateaos_get_links = function (hateoas_obj, target) {
  if (hateoas_obj && hateoas_obj._links && hateoas_obj._links[target]) {
    return hateoas_obj._links[target].href;
  }
};
Vue.prototype.$cognito = awsCognito;
Vue.prototype.$http = api_client;
Vue.prototype.$traceApi = trace_api_client;
Vue.prototype.$traceApiURL = traceURI;
Vue.prototype.$getOrganization = async function () {
  // console.log(this.org, 'init org')

  const orgid = {
    '풀무원': 1,
    '하림': 3,
    '롯데마트': 8,
    '동원산업': 236,
    '씨푸드레스토랑': 237,
    '보은대추농장': 5782,
    '고려인삼농장': 5783,
    '후쿠시마이력추적': 6680,
    '후쿠시마이력추적데모':7171
  }
  if (!this.org) {
    const orgname = await new awsCognito().getOrgName();//동적로딩으로 !!
    const response = await this.$http.get(`api/organization/search/findByOrganizationName?organizationName=${orgname}`);
    this.org = response.data;
    this.org_id = response.data.id;
  }
  return this.org;
};

Vue.prototype.$profile = async function () {
  // console.log(this.profile, 'init profile')
  if (!this.profile) {
    const response = await this.$http.get(`api`);
    this.profile = response.data;
  }
  return this.profile;
};

api_client.interceptors.request.use(function (config) {
  // Do something before request is sent

  if (!config.url.startsWith('http')) {
    config.url = baseURI + '/' + config.url;
  }
  new awsCognito().getToken(function (err, data) {

    if (err) {
      alert('세션이 만료되었습니다.')
      router.push('/')
      return;
    }

    const token = data.jwtToken;
    config.headers["Authorization"] = token;
  })
  return config;
});

trace_api_client.interceptors.request.use(function (config) {
  // Do something before request is sent

  if (!config.url.startsWith('http')) {
    config.url = traceURI + '/' + config.url;
  }
  new awsCognito().getToken(function (err, data) {

    if (err) {
      alert('세션이 만료되었습니다.')
      router.push('/')
      return;
    }

    const token = data.jwtToken;
    config.headers["Authorization"] = token;
  })
  return config;
});

//TODO: create & move to {util}.js
Date.prototype.format = function (formatter) {
  function setZeros(n, digits) {
    var zero = '';
    n = n.toString();
    if (n.length < digits) {
      for (var i = 0; i < digits - n.length; i++) {
        zero += '0';
      }
    }
    return zero + n;
  }
  var d = this;
  var yyyy = setZeros(d.getFullYear(), 4);
  var mm = setZeros(d.getMonth() + 1, 2);
  var dd = setZeros(d.getDate(), 2);
  var hh = setZeros(d.getHours(), 2);
  var mi = setZeros(d.getMinutes(), 2);
  var ss = setZeros(d.getSeconds(), 2);

  formatter = formatter.replace('yyyy', yyyy);
  formatter = formatter.replace('mm', mm);
  formatter = formatter.replace('dd', dd);
  formatter = formatter.replace('hh', hh);
  formatter = formatter.replace('mi', mi);
  formatter = formatter.replace('ss', ss);

  return formatter;
}
const cog = new awsCognito();
// 페이지 진입시 권한체크
router.beforeEach(function (to, from, next) {

  /* 0. 권한 체크가 필요한 페이지인지 확인 */
  var isAuthRequired = to.matched.some(function (routeInfo) {
    // 페이지별 권한설정시 /src/router/index.js 변경
    return routeInfo.meta.authRequired;
  });

  if (!isAuthRequired) {
    console.log("routing success : '" + to.path + "'");
    next(); // 페이지 전환
  } else {
    /* 1. 세션 존재하는지 체크 */
    cog.cognito_user_get_session(
      function (error, session) {
        if (error) {
          alert('세션이 만료되었습니다. 다시 로그인해주세요.');
          next('/pages/login');
          // next()
        } else {

          has_expire(session.idToken.jwtToken)
            .then(function () {
              console.log('>> token is not expire');
              // 권한 체크 필요시 추가 작성하여 사용
              cog.cognito_user_get_group(
                function (error, group) {
                  if (error) {
                    next('/pages/login');
                  } else {
                    // console.log('======>>>>>>>>', group, to.fullPath)
                    if (group == 'manager') {  // 매니저그룹이 시스템 페이지 접속시 -> 진행
                      next();
                    } else if (group == 'admin') {  // 운영자그룹이 시스템 페이지 접속시 -> 진행
                      if(!to.fullPath.startsWith('/admin')) {
                        next('/admin');
                      }
                      // console.log(to)
                      next();
                    } else {
                      alert('접근 불가능한 페이지입니다');
                      next('/pages/login');
                    }
                    // next();
                  }
                }
              )
            })
            .catch(function () {
              // refreshToken을 이용하여 token 갱신
              console.log('>> token expire error catch')
              cog.cognito_user_refresh_session(session.refreshToken, function (error) {
                if (error) {
                  console.log('>> refresh session by refreshToken');
                  next('/pages/login');
                } else {
                  next();
                }
              });

            })
        }
      }
    );
  };





});

Vue.use(BootstrapVue)
Vue.use(datePicker)
Vue.use(BootstrapVueIcons)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBnGK5lVzvJcWzgisxjg1ptPpwkhyoq4LA",
    libraries: "places"
  }
});
// Vue.directive('scroll', {
//   inserted(el) {
//     // Create a new PerfectScrollbar instance
//     const ps = new PerfectScrollbar(el, { suppressScrollX: true });

//     // Event listener for mouse wheel event
//     el.addEventListener('ps-scroll-y', () => {
//       if (el.scrollTop === 0) {
//         // Prevent default action for passive event listeners
//         el.style.touchAction = 'none';
//       } else {
//         el.style.touchAction = 'auto';
//       }
//     });

//     // Clean up the PerfectScrollbar instance when the element is unbound
//     el._ps_cleanup = () => {
//       ps.destroy();
//       el.removeEventListener('ps-scroll-y');
//     };
//   },
//   unbind(el) {
//     if (el._ps_cleanup) {
//       el._ps_cleanup();
//     }
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App, datePicker
  }
})
